"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MicrophoneOff = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var MicrophoneOff = function MicrophoneOff() {
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("g", {
    clipPath: "url(#clip0_501_473)"
  }, react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.602 9.6V4.8a4.8 4.8 0 00-4.8-4.8 4.8 4.8 0 00-4.464 3.084l8.724 8.724a4.73 4.73 0 00.54-2.208zm5.82 12.384l-.636.636a.576.576 0 01-.84 0L16.35 18a9.382 9.382 0 01-3.348 1.08v2.52h1.8a.6.6 0 01.6.6v1.2a.6.6 0 01-.6.6h-6a.6.6 0 01-.6-.6v-1.2a.6.6 0 01.6-.6h1.8v-2.484a9.672 9.672 0 01-7.2-4.884.672.672 0 010-.48.636.636 0 01.324-.36l1.08-.504a.588.588 0 01.78.24 7.2 7.2 0 009.024 3.108l-1.92-1.92A4.8 4.8 0 017.002 9.6v-.912l-5.82-5.832a.576.576 0 010-.84l.636-.636a.576.576 0 01.84 0l19.764 19.764a.576.576 0 010 .84zm-2.22-8.232c.059.155.059.325 0 .48a8.678 8.678 0 01-.732 1.044l-1.716-1.716c.096-.144.18-.288.264-.432a.588.588 0 01.78-.24l1.08.504a.636.636 0 01.324.36z",
    clipRule: "evenodd"
  })), react_1.default.createElement("defs", null, react_1.default.createElement("clipPath", {
    id: "clip0_501_473"
  }, react_1.default.createElement("path", {
    fill: "currentColor",
    d: "M0 0H24V24H0z"
  }))));
};

exports.MicrophoneOff = MicrophoneOff;